{
  "0ddf43e264f68a12": "Hora solicitada",
  "0f295eecfb3433d7": "Turnos Verificados",
  "19c73a5cdf346d96": "Profesional",
  "1c525cb12fd03c7c": "Detalles de la tarifa",
  "2035fb74b10109c5": "Solicitud de pago de descanso pendiente",
  "215020d85a22dd6d": "Desglose de cargos",
  "33c8e8de41c3a351": "No verificado",
  "3a8931a9b2f6bf69": "Disputa",
  "3c653dabeef2e3c2": "Turnos",
  "3ec6e3941da4c010": "¿Verificar Turno?",
  "45989de49fb7f66d": "Detalles",
  "45b63ffd01af7b9c": "Tarifa",
  "4f7838402f37674e": "Verificado",
  "526e0087cc3f254d": "Descripción",
  "62d6ee886349c247": "Horarios de turnos",
  "6d80486cc33a915c": "Honorarios",
  "79c2657890c42470": "Ver disputa",
  "833f7959e353683d": "No se pueden verificar los turnos que aún no han comenzado",
  "872d718dc4dcdfb8": "Sin turnos verificados",
  "87b17944085875ed": "Solicitudes Pendientes",
  "883a9f47c79e8901": "Sin solicitudes pendientes",
  "88494a53861aa061": "Fuera de ciclo",
  "8cd819f501f556ca": "Error al cargar los cargos pendientes. Por favor, inténtalo de nuevo más tarde.",
  "920e413c7d411b61": "Estado",
  "942087cc2d41e013": "Reintentar",
  "96173be4ed57f043": "Sin tarifas",
  "99c40ab405926cb5": "Fecha",
  "9a57000511753181": "Tipo de Honorario",
  "a2fb237d15320535": "Cargos Pendientes",
  "a600b900f83db6cb": "Cerrar panel",
  "ad30ad3bffc8184d": "Tipo de turno",
  "aff0766a5290e117": "Revisar",
  "b3b310ca1276b3bb": "Disputado",
  "b5396293134e602c": "Error al cargar las solicitudes pendientes. Por favor, inténtalo de nuevo más tarde.",
  "bdd239ff57e1d330": "Expira en {{formattedExpiration}}",
  "c011d6097bfbc8e9": "Licencia",
  "c972b45d5870fe90": "Cargos adicionales por cancelaciones tardías, turnos enviados a casa y otros honorarios no relacionados con turnos.",
  "c9b3c38247f744e1": "Total",
  "ccde26902b9baa9d": "Horas pagadas",
  "d1bf045bb524dae5": "Ver detalles",
  "d8edefa82a64defb": "Horas pagadas",
  "ebe4ecdf967339f2": "Expiración N/A",
  "f57c4300d5f50247": "Tarifa (/hr)",
  "f71081fb0af48ae6": "Descanso"
}
